/*
  Cutoff schedule helpers. RepeatDays is a weekday bitmask shared with
  SP_CutoffLunchSchedule: Sun 1, Mon 2, Tue 4, Wed 8, Thu 16, Fri 32, Sat 64.
*/

export const WEEK_DAYS = [
    { bit: 2, label: 'Mon' },
    { bit: 4, label: 'Tue' },
    { bit: 8, label: 'Wed' },
    { bit: 16, label: 'Thu' },
    { bit: 32, label: 'Fri' },
    { bit: 64, label: 'Sat' },
    { bit: 1, label: 'Sun' },
];

export const ALL_DAYS = 127;
export const WEEKDAYS = 62; // Mon-Fri

export const REPEAT = { ONCE: 'once', DAILY: 'daily', WEEKDAYS: 'weekdays', CUSTOM: 'custom' };

export const REPEAT_OPTIONS = [
    { id: REPEAT.ONCE, name: 'Once (pick a date)' },
    { id: REPEAT.DAILY, name: 'Every day' },
    { id: REPEAT.WEEKDAYS, name: 'Weekdays (Mon - Fri)' },
    { id: REPEAT.CUSTOM, name: 'Custom days' },
];

// The repeat choice a saved schedule was made with
export const repeatOf = (row) => {
    if (!row) return REPEAT.DAILY
    if (row.StartDate && row.StartDate === row.EndDate) return REPEAT.ONCE
    if (+row.RepeatDays === ALL_DAYS) return REPEAT.DAILY
    if (+row.RepeatDays === WEEKDAYS) return REPEAT.WEEKDAYS
    return REPEAT.CUSTOM
}

export const daysFor = (repeat, customDays) => {
    if (repeat === REPEAT.WEEKDAYS) return WEEKDAYS
    if (repeat === REPEAT.CUSTOM) return customDays
    return ALL_DAYS
}

const dayNames = (mask) => WEEK_DAYS.filter((d) => (mask & d.bit) !== 0).map((d) => d.label).join(', ')

const shortDate = (iso) => {
    if (!iso) return ''
    const [y, m, d] = iso.split('-')
    const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][+m - 1]
    return `${d} ${month} ${y}`
}

export const formatDate = shortDate

// "Every day from 05 Nov 2026", "Mon, Wed until 30 Nov 2026", "Once on 07 Nov 2026", "Manual"
export const scheduleSummary = (row) => {
    if (!row.AutoGenerate) return 'Manual (generate when needed)'
    const repeat = repeatOf(row)
    if (repeat === REPEAT.ONCE) return `Once on ${shortDate(row.StartDate)}`
    const what = repeat === REPEAT.DAILY ? 'Every day' : repeat === REPEAT.WEEKDAYS ? 'Mon - Fri' : dayNames(+row.RepeatDays)
    return `${what} from ${shortDate(row.StartDate)}${row.EndDate ? ` until ${shortDate(row.EndDate)}` : ''}`
}

export const statusOf = (row, today) => {
    if (row.AutoGenerate && row.EndDate && row.EndDate < today) return 'Ended'
    return row.bIsActive ? 'Active' : 'Paused'
}
